import { Component, Input, OnInit } from '@angular/core';
import { FormField } from '../models/form-field';
import { Constants } from '@shared/services/constants/constants';
import { ApplicantService } from '@shared/services/forms/applicant.service';

@Component({
  selector: 'app-aaos-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss']
})
export class LabelComponent implements OnInit {
  @Input() field: FormField;

  constructor(private applicantService: ApplicantService) { }

  ngOnInit() {

    const applicationTypeId = this.applicantService.getApplicationTypeId().toLowerCase();

    if (this.field?.id.toUpperCase() === Constants.FormField.SponsorLetterRecLabel1Id &&
      applicationTypeId.toUpperCase() === Constants.MemberApplicationTypes.AHMOrthoTeamId) {
      var customOrthoTeamLabel = ' You may use this document as a template: <a href="assets/docs/AAOS Member Sponsorship Letter for Allied - Ortho Team Application.docx" target="_blank">AAOS Member Sponsorship Letter for Allied - Ortho Team Application.</a>'
      if (this.field.displayName.includes(customOrthoTeamLabel) == false) {
        this.field.displayName = this.field.displayName + customOrthoTeamLabel;
      }
    }
  }
}
